import React from 'react';

const SuccessModal = ({ onClose }) => {
  const registrationData = JSON.parse(
    localStorage.getItem('completeRegistrationData') || '{}'
  );

  const mobile = registrationData.mobile || localStorage.getItem('guestMobile') || '';

  const maskEmail = (email) => {
    if (!email) return '';
    const [username, domain] = email.split('@');
    if (username.length <= 3) return email;
    return username.substring(0, 3) + '...' + username.slice(-2) + '@' + domain;
  };

  const maskMobile = (mob) => {
    if (!mob) return '';
    if (mob.length !== 10) return mob;
    return mob.substring(0, 4) + '....' + mob.slice(-2);
  };

  return (
    <div className="modal active">
      <div className="modal-content">
        <div className="success-icon">✓</div>
        <h3>Registration Successful!</h3>
        <p>
          Registration done successfully with registration ID{' '}
          <strong>{registrationData.registrationId || 'Pending'}</strong>.{' '}
          {registrationData.email && (
            <>
              For further details on admission process please check the email sent on{' '}
              <strong>{maskEmail(registrationData.email)}</strong>
              {mobile && (
                <> or the SMS sent on <strong>{maskMobile(mobile)}</strong></>
              )}.
            </>
          )}
        </p>

        {/* Registration ID badge */}
        {registrationData.registrationId && (
          <div className="modal-id">
            Registration ID: {registrationData.registrationId}
          </div>
        )}

        {/* Extra details */}
        <div style={{ textAlign:'left', margin:'14px 0', fontSize:14, lineHeight:1.8 }}>
          {registrationData.fullName && (
            <div><span style={{ color:'#666' }}>Student Name: </span><strong>{registrationData.fullName}</strong></div>
          )}
          {mobile && (
            <div style={{ display:'flex', alignItems:'center', gap:6 }}>
              <span style={{ color:'#666' }}>Mobile: </span>
              <strong style={{ background:'#f0fff4', padding:'1px 8px', borderRadius:12, border:'1px solid #c8e6c9', color:'#2D5F4F' }}>
                {mobile}
              </strong>
              <svg width="18" height="18" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" style={{flexShrink:0}}>
                <circle cx="16" cy="16" r="16" fill="#25D366"/>
                <path d="M23.5 8.5A10.4 10.4 0 0 0 16 5.5C10.2 5.5 5.5 10.2 5.5 16c0 1.8.5 3.6 1.4 5.2L5.5 26.5l5.4-1.4A10.4 10.4 0 0 0 16 26.5c5.8 0 10.5-4.7 10.5-10.5 0-2.8-1.1-5.4-3-7.5zm-7.5 16.1a8.6 8.6 0 0 1-4.4-1.2l-.3-.2-3.2.8.8-3.1-.2-.3A8.6 8.6 0 1 1 16 24.6zm4.7-6.4c-.3-.1-1.6-.8-1.8-.9-.3-.1-.5-.1-.7.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.8-.7-1.4-1.6-1.6-1.9-.2-.3 0-.4.1-.6l.4-.5c.1-.2.2-.3.2-.5 0-.2 0-.3-.1-.5-.1-.2-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.2.2 2 3 4.8 4.2.7.3 1.2.4 1.6.5.7.2 1.3.2 1.8.1.6-.1 1.6-.6 1.9-1.2.3-.6.3-1.1.2-1.2-.1-.1-.3-.2-.6-.3z" fill="white"/>
              </svg>
              <span style={{ fontSize:11, color:'#25D366', fontWeight:600 }}>Details sent on WhatsApp</span>
            </div>
          )}
          {registrationData.email && (
            <div><span style={{ color:'#666' }}>Email: </span><strong>{maskEmail(registrationData.email)}</strong></div>
          )}
        </div>

        <p style={{ fontSize:'14px', color:'#666', marginTop:'10px' }}>
          Status: <strong style={{ color:'#f39c12' }}>Pending Approval</strong>
        </p>

        <button className="btn-primary" onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default SuccessModal;